import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import Dialog from '../../organisms/Dialog';
import CommodityForm from './shared/CommodityForm';
import useCommodityPageForm from '../../../hooks/useCommodityPageForm';

interface CommodityListContext {
    refresh: () => void;
}

const CommodityAssetPageForm = () => {
    const navigate = useNavigate();
    const context = useOutletContext<CommodityListContext>();

    const handleClose = () => navigate('/collateral/commodities');

    const handleSuccess = () => {
        toast.success('Grãos cadastrados com sucesso');
        context?.refresh();
        handleClose();
    };

    const form = useCommodityPageForm({ onClose: handleClose, onCreated: handleSuccess });

    return (
        <Dialog
            id="commodity-asset-form"
            show={true}
            onClose={handleClose}
            header="Novos Grãos"
            size="lg"
            body={<CommodityForm {...form} />}
            footer={
                <div className="flex gap-2">
                    <button onClick={handleClose} disabled={form.isCreating}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm disabled:opacity-50">
                        Cancelar
                    </button>
                    <button onClick={form.handleCreate} disabled={form.isCreating}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50">
                        {form.isCreating ? 'Salvando...' : 'Cadastrar'}
                    </button>
                </div>
            }
        />
    );
};

export default CommodityAssetPageForm;
